/**
 * KnowledgeProfileHome — this app's full-screen surface for the nurse's
 * knowledge profile.
 *
 * It is app CHROME plus the agent's FACE, and nothing else. The dashboard
 * itself — the list and knowledge-map views over her skills fold, the
 * self-declare form, the endorsements behind a row, the per-row busy state —
 * lives in the component the face mounts
 * (../components/knowledgeProfile/KnowledgeProfileConnected), this agent's own.
 *
 * This page used to re-implement all of that: 221 lines here against 211 in the
 * shared component, rendering the same views from the same primitives. Two
 * copies of one clinical surface, free to drift — a fix or a wording change
 * landing in one and not the other, with nothing to catch it. The face is now
 * the single implementation, mounted in-frame by the main app and full-screen
 * here.
 *
 * The face brings its own scroll container and max-width, so this page adds
 * only the header.
 */
import { useTranslation } from 'react-i18next'

import { MainAppNav } from '@frontend/components/MainAppNav'
import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'

import Face from '../face'

function Header() {
  const { t } = useTranslation()
  return (
    <header className="flex items-center gap-2 border-b border-[var(--color-surface-border)] bg-[var(--color-surface-bg)] px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
      <ReturnToMainAgent className="-ml-2" />
      <h1 className="min-w-0 flex-1 truncate text-[19px] font-semibold tracking-[-0.01em] text-[var(--color-surface-ink)]">
        {t('skills.header.title')}
      </h1>
      <MainAppNav />
    </header>
  )
}

export default function KnowledgeProfileHome() {
  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      <Header />
      <main className="min-h-0 flex-1">
        <Face />
      </main>
    </div>
  )
}
